// Vendor imports
const { useSelector } = require('react-redux')
// Client V2 common imports
const { useExperiment, useRollout } = require('client-v2/common/containers/rollouts')
const useMatchMedia = require('client-v2/common/hooks/match-media')

function useHasSidebar() {
  const isExperimentActive = useRollout('*web_sidebar')
  const experimentModifier = useExperiment('*web_sidebar')
  let hasSidebar = isExperimentActive && experimentModifier !== 'disabled'
  const isWindowTooNarrow = useMatchMedia('(max-width: 1200px)')
  if (isWindowTooNarrow) {
    hasSidebar = false
  }
  const isLoggedIn = useSelector(state => state.user.loggedIn)
  if (!isLoggedIn) {
    hasSidebar = false
  }
  return hasSidebar
}

module.exports = {
  useHasSidebar
}
